import React, { useContext, useEffect, useRef, useCallback } from 'react'
import get from 'lodash/get'
import fetch from 'isomorphic-unfetch'
import classnames from 'classnames'
import { on, off } from '@arsenal/arsenal/modules/event'

import { sendTeaCommEvent } from 'lib/tea-analyze'
import getUrl from 'lib/url'
import { useScrollSpy } from 'Components/hooks'
import { GlobalStoreContext } from 'Components/store'

export interface ICity {
  /* 城市首字母 */
  initials: string
  /* 城市列表 */
  city: [
    {
      city_name: string
    }
  ]
}

interface IProps {
  onChange?(cityName?: string): void
  showNationWide?: boolean
  isLocalUse?: boolean
}

export default function City(props: IProps) {
  const { onChange, showNationWide, isLocalUse } = props
  // 设置全局的城市
  const { state: globalStore, dispatch } = useContext(GlobalStoreContext)
  const { cities } = globalStore

  // 整体dom
  const ref = useRef<HTMLDivElement>(null)

  const [currIndex, setCurrIndex, cityRef] = useScrollSpy<
    HTMLElement,
    HTMLDivElement
  >((node) => {
    return node.querySelectorAll('.cities')
  }, false)
  /* 获取城市列表 */
  const fetchCities = useCallback(() => {
    return fetch(getUrl('/motor/dealer/m/v1/get_dealer_city_list/'))
      .then((res) => res.json())
      .then((json) => {
        const data = get(json, 'data', [])
        if (data.length) {
          data.unshift({
            initials: '热门城市',
            city: [
              { city_name: '北京', initials: '热门城市' },
              { city_name: '上海', initials: '热门城市' },
              { city_name: '广州', initials: '热门城市' },
              { city_name: '深圳', initials: '热门城市' },
              { city_name: '重庆', initials: '热门城市' },
              { city_name: '天津', initials: '热门城市' },
              { city_name: '成都', initials: '热门城市' },
              { city_name: '杭州', initials: '热门城市' },
              { city_name: '武汉', initials: '热门城市' },
              { city_name: '苏州', initials: '热门城市' },
              { city_name: '西安', initials: '热门城市' },
              { city_name: '南京', initials: '热门城市' },
            ],
          })
          if (showNationWide) {
            data.unshift({
              initials: '全国',
              city: [{ city_name: '全国', initials: '全国' }],
            })
          }
        }
        if (!isLocalUse)
          dispatch({
            type: 'setCities',
            payload: data,
          })
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (!cities || !cities.length) {
      fetchCities()
    }
  }, [cities, fetchCities])
  useEffect(() => {
    function handleDocumentClick(e: Event) {
      if (!ref.current || ref.current.contains(e.target as Node)) {
        return
      }
      onChange && onChange()
      // setCity(Object.assign({}, city, { show: false }))
    }
    on(window, 'click', handleDocumentClick)
    return () => {
      off(window, 'click', handleDocumentClick)
    }
  }, [onChange])

  /*  渲染城市首字母 */
  function renderLetter() {
    if (!cities) {
      return null
    }
    return (
      <div>
        {cities.map((item, index) => (
          <span
            data-letter={item.initials}
            key={item.initials}
            className={classnames({
              active: currIndex === index,
            })}
            onClick={() => {
              setCurrIndex(index)
              // scrollView(item.initials)
            }}
          >
            {item.initials.slice(0, 1).toLocaleUpperCase()}
          </span>
        ))}
        <style jsx>
          {`
            div {
              display: inline-block;
              width: 43px;
              height: 100%;
              line-height: 0;
              padding: 12px 8px;
              vertical-align: top;
              border-right: 1px solid #e6e6e6;
            }
            span {
              display: inline-block;
              width: 26px;
              height: 26px;
              line-height: 26px;
              font-size: 14px;
              text-align: center;
              border-radius: 2px;
            }
            span:hover {
              background-color: #fff2ce !important;
            }
            .active {
              background: #ffcd32;
              font-weight: 500;
              transition: all 0.2s ease;
            }
          `}
        </style>
      </div>
    )
  }

  /* 渲染城市列表 */
  function renderCities() {
    if (!cities) {
      return null
    }
    return (
      <section className="city-section-wrap" ref={cityRef}>
        {cities.map((city) => {
          return (
            <div
              className="cities"
              key={city.initials}
              data-letter={city.initials}
            >
              <h4>{city.initials.toLocaleUpperCase()}</h4>
              {city.city.map((item: ICity['city'][0]) => (
                <span
                  key={item.city_name}
                  onClick={() => {
                    // setCity({ show: false, name: item.city_name })
                    sendTeaCommEvent('clk_event', {
                      event_id: 'common_city_select_menu',
                    })
                    if (!isLocalUse)
                      dispatch({
                        type: 'setCityName',
                        payload: item.city_name,
                      })
                    if (onChange) {
                      onChange(item.city_name)
                    }
                  }}
                >
                  {item.city_name}
                </span>
              ))}
            </div>
          )
        })}
        <style jsx>
          {`
            section {
              display: inline-block;
              width: 307px;
              height: 100%;
              margin: 12px 0;
              overflow-y: auto;
              transform: translateZ(0);
              overscroll-behavior: none;
              cursor: pointer;
            }
            section::-webkit-scrollbar {
              width: 5px;
              background-color: rgba(0, 0, 0, 0);
            }
            section::-webkit-scrollbar-thumb {
              border-radius: 5px;
              background-color: rgba(0, 0, 0, 0);
              transition: all 0.2s linear;
            }
            section::-webkit-scrollbar-track {
              border-radius: 55px;
              background-color: rgba(0, 0, 0, 0);
            }
            div {
              line-height: 0;
              padding-bottom: 8px;
            }
            h4 {
              position: sticky;
              top: 0px;
              line-height: 28px;
              margin-bottom: 8px;
              padding-left: 16px;
              font-size: 12px;
              color: #666;
              background: #f7f8fc;
              font-weight: normal;
            }
            span {
              display: inline-block;
              width: 25%;
              line-height: 22px;
              padding: 8px 0;
              text-align: center;
            }
            span:hover {
              background-color: rgba(255, 225, 0, 0.2);
            }
          `}
        </style>
      </section>
    )
  }
  if (!cities || !cities.length) {
    return null
  }
  return (
    <section
      ref={ref}
      onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.stopPropagation()
      }}
    >
      {renderLetter()}
      {renderCities()}
      <style jsx>
        {`
          section {
            width: 350px;
            height: 616px;
            overflow: hidden;
            color: #1f2129;
          }
        `}
      </style>
    </section>
  )
}
